// extracted by mini-css-extract-plugin
export default {"appLogo":"AppLogo_appLogo__qViL2"};